import { render } from "./TheFooterContact.vue?vue&type=template&id=25137370&scoped=true"
import script from "./TheFooterContact.vue?vue&type=script&lang=js"
export * from "./TheFooterContact.vue?vue&type=script&lang=js"

import "./TheFooterContact.vue?vue&type=style&index=0&id=25137370&lang=scss&scoped=true"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25137370"]])

export default __exports__